<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="props.width" :height="props.height" viewBox="0 0 22 22">
    <g id="Group_1335" data-name="Group 1335" transform="translate(1 1)">
      <path
        id="Path_4754"
        data-name="Path 4754"
        d="M21,12.364V9.636l-2.953-.4a7.206,7.206,0,0,0-.818-1.968l1.8-2.373L17.107,2.965l-2.373,1.8a7.206,7.206,0,0,0-1.968-.818L12.364,1H9.636l-.4,2.953a7.206,7.206,0,0,0-1.968.818L4.893,2.965,2.965,4.893l1.8,2.373A7.206,7.206,0,0,0,3.95,9.234L1,9.636v2.727l2.953.4a7.206,7.206,0,0,0,.818,1.968l-1.8,2.373L4.9,19.035l2.373-1.8a7.206,7.206,0,0,0,1.968.818l.4,2.95h2.727l.4-2.953a7.206,7.206,0,0,0,1.968-.818l2.373,1.8L19.035,17.1l-1.8-2.373a7.206,7.206,0,0,0,.818-1.968Z"
        transform="translate(-1 -1)"
        fill="none"
        :stroke="props.color"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <circle
        id="Ellipse_174"
        data-name="Ellipse 174"
        cx="3"
        cy="3"
        r="3"
        transform="translate(7 7)"
        fill="none"
        :stroke="props.color"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface CogWheelProps {
  width?: string;
  height?: string;
  color?: string;
}

const props = withDefaults(defineProps<CogWheelProps>(), {
  width: "22",
  height: "22",
  color: "#991e66",
});
</script>
